import { TagNFeSaidaResumoStruct } from '@shared/services/structs/repo-dfe/tag-nfe-saida-resumo.struct';

export class AlterarTagsNotaFiscalSaidaDialogData {
  idsNFeSaida: number[];
  tags: TagNFeSaidaResumoStruct[];
  idsTagsAtuais: number[];
}
